import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
import { styled } from "@mui/material/styles";
import { List } from "@biome-design-system/ui/List";
import { Typography } from "@biome-design-system/ui/Typography";
import { useFocusManager } from "@biome-design-system/ui/useFocusManager";
import { useFilterWizardContext } from "./FilterWizardContext.js";
import { DefaultQuestionStepAnswer } from "./DefaultQuestionStepAnswer.js";
const QuestionHeader = styled(Typography, {
  name: "MuiFilterWizard",
  slot: "questionHeader"
})(() => ({}));
const Answers = styled(List, {
  name: "MuiFilterWizard",
  slot: "answers"
})(() => ({}));
const DefaultQuestionStep = ({
  labels
}) => {
  const { currentQuestion, handleAnswer } = useFilterWizardContext();
  const { containerProps, getItemProps } = useFocusManager({
    autoFocusFirstElement: true,
    itemRole: "button",
    orientation: "vertical"
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      QuestionHeader,
      {
        component: "legend",
        "data-testid": "filter-wizard-question-text",
        id: "filter-wizard-question-text",
        variant: "h2",
        children: currentQuestion.text
      }
    ),
    /* @__PURE__ */ jsx(
      Answers,
      {
        ...containerProps,
        "aria-labelledby": "filter-wizard-question-text",
        "data-testid": "filter-wizard-question-answers",
        children: currentQuestion.answers.map(({ answer: a }, idx) => /* @__PURE__ */ createElement(
          DefaultQuestionStepAnswer,
          {
            ...getItemProps(idx),
            answer: a,
            "data-testid": `filter-wizard-answer-${a.psr_id}`,
            key: a.psr_id,
            labels,
            onClick: () => {
              handleAnswer(a);
            }
          }
        ))
      }
    )
  ] });
};
export {
  DefaultQuestionStep
};
